import { render, staticRenderFns } from "./ProjectKPIs.vue?vue&type=template&id=bff57298&scoped=true&"
import script from "./ProjectKPIs.vue?vue&type=script&lang=js&"
export * from "./ProjectKPIs.vue?vue&type=script&lang=js&"
import style0 from "./ProjectKPIs.vue?vue&type=style&index=0&id=bff57298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff57298",
  null
  
)

export default component.exports